// import React, { useEffect, useRef } from "react";
// import "./Events.css";

// import img1 from "../../assets/Events/celebs/govinda.webp";
// import img2 from "../../assets/Events/celebs/Lucky-Ali.webp";
// import img3 from "../../assets/Events/celebs/nehakakkar.webp";
// import img4 from "../../assets/Events/celebs/prachi-desai.webp";
// import img5 from "../../assets/Events/celebs/Prince_Narula.webp";
// import img6 from "../../assets/Events/celebs/pritam (1).webp";
// import img7 from "../../assets/Events/celebs/shaan.webp";
// import img8 from "../../assets/Events/celebs/shreya.webp";
// import img9 from "../../assets/Events/celebs/sonunigam.webp";
// import img10 from "../../assets/Events/celebs/hussain-kuwajerwala.webp";
// import img11 from "../../assets/Events/celebs/motorola.webp";
// import img12 from "../../assets/Events/celebs/kutle khan.webp";
// import img13 from "../../assets/Events/celebs/mame khan.webp";
// import img14 from "../../assets/Events/celebs/motorola4.webp";
// import img15 from "../../assets/Events/celebs/Pritam1.webp";
// import img16 from "../../assets/Events/celebs/motorola.webp";
// import vid17 from "../../assets/Events/celebs/shaan video.webm";
// import img18 from "../../assets/Events/celebs/motorola1.webp";
// import img19 from "../../assets/Events/celebs/motorola3.webp";
// import img21 from "../../assets/Events/celebs/motorola5.webp";
// import vid20 from "../../assets/Events/celebs/bangkok (1).webm";

// const media = [
//   vid17,img1, img2, img3, img4, img5, img6,
//   img7, img8, img9, img10, img11, img12,
//   img13, img14, img15, img16, img18,
//   img19,img21
// ];

// function Events() {
//   const containerRef = useRef(null);

//   useEffect(() => {
//     const panels = containerRef.current.querySelectorAll(".panel");
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             entry.target.classList.add("visible");
//           } else {
//             entry.target.classList.remove("visible");
//           }
//         });
//       },
//       { threshold: 0.2 }
//     );

//     panels.forEach((panel) => observer.observe(panel));
//     return () => panels.forEach((panel) => observer.unobserve(panel));
//   }, []);


//   return (
//     <div className="events-page"> 
//       <h1 className="eventhead">ATH Events</h1>
//       <div className="grids-container" ref={containerRef}>
//         {media.map((item, idx) => (
//           <div
//             className={`panel ${idx % 2 === 0 ? "from-left" : "from-right"}`}
//             key={idx}
//           >
//             {item.endsWith(".webm") ? (
//               <video
//                 src={item}
//                 autoPlay
//                 loop
//                 muted
//                 playsInline
//               />
//             ) : (
//               <img src={item} alt={`event-${idx}`} />
//             )}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default Events;



import React, { useEffect, useRef } from "react";
import "./Events.css";

import img1 from "../../assets/Events/celebs/govinda.webp";
import img2 from "../../assets/Events/celebs/Lucky-Ali.webp";
import img3 from "../../assets/Events/celebs/nehakakkar.webp";
import img4 from "../../assets/Events/celebs/prachi-desai.webp";
import img5 from "../../assets/Events/celebs/Prince_Narula.webp";
import img6 from "../../assets/Events/celebs/pritam (1).webp";
import img7 from "../../assets/Events/celebs/shaan.webp";
import img8 from "../../assets/Events/celebs/shreya.webp";
import img9 from "../../assets/Events/celebs/sonunigam.webp";
import img10 from "../../assets/Events/celebs/hussain-kuwajerwala.webp";
import img11 from "../../assets/Events/celebs/motorola.webp";
import img12 from "../../assets/Events/celebs/kutle khan.webp";
import img13 from "../../assets/Events/celebs/mame khan.webp";
import img14 from "../../assets/Events/celebs/motorola4.webp";
import img15 from "../../assets/Events/celebs/Pritam1.webp";
import img16 from "../../assets/Events/celebs/motorola.webp";
import vid17 from "../../assets/Events/celebs/shaan video.webm";
import img18 from "../../assets/Events/celebs/motorola1.webp";
import img19 from "../../assets/Events/celebs/motorola3.webp";
import img21 from "../../assets/Events/celebs/motorola5.webp";
import vid20 from "../../assets/Events/celebs/bangkok (1).webm";

const media = [
  vid17,img1, img2, img3, img4, img5, img6,
  img7, img8, img9, img10, img11, img12,
  img13, img14, img15, img16, img18,
  img19,img21
];

function Events() {
  const containerRef = useRef(null);

  useEffect(() => {
    const panels = containerRef.current.querySelectorAll(".panel");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          } else {
            entry.target.classList.remove("visible");
          }
        });
      },
      { threshold: 0.2 }
    );

    panels.forEach((panel) => observer.observe(panel));
    return () => panels.forEach((panel) => observer.unobserve(panel));
  }, []);
  


useEffect(() => {
  const section = containerRef.current;
  if (!section) return;

  let scrollFrame;
  let autoScrolling = false;

  const scrollStep = () => {
    if (!autoScrolling) return;

    const rect = section.getBoundingClientRect();

    if (rect.top < window.innerHeight && rect.bottom > 0) {
      window.scrollBy(0, 3); // speed control
      scrollFrame = requestAnimationFrame(scrollStep);
    } else {
      stopAutoScroll();
    }
  };

  const startAutoScroll = () => {
    if (autoScrolling) return;
    autoScrolling = true;
    scrollFrame = requestAnimationFrame(scrollStep);
  };

  const stopAutoScroll = () => {
    autoScrolling = false;
    cancelAnimationFrame(scrollFrame);
  };

  const toggleAutoScroll = () => {
    if (autoScrolling) {
      stopAutoScroll();
    } else {
      startAutoScroll();
    }
  };

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        startAutoScroll();
      } else {
        stopAutoScroll();
      }
    }
  );

  observer.observe(section);

  section.addEventListener("click", toggleAutoScroll);
  section.addEventListener("touchstart", toggleAutoScroll);

  return () => {
    observer.disconnect();
    stopAutoScroll();
    section.removeEventListener("click", toggleAutoScroll);
    section.removeEventListener("touchstart", toggleAutoScroll);
  };
}, []);




  return (
    <main className="events-page">

      {/* SEO Header Section */}
    <header className="events-header">
  <h1 className="eventhead">
    Celebrity & Corporate Events Managed by Atlas Travel House
  </h1>
  <p className="events-intro">
    Explore highlights from our successfully executed celebrity shows,
    brand activations, corporate gatherings, luxury destination events,
    and international performances across India and abroad.
  </p>
</header>

<section className="events-content">
  <h2>Professional Event Management Services in India</h2>

  <p>
    Atlas Travel House is a leading event management company in India,
    specializing in celebrity event management, corporate event planning,
    brand activations, live concerts, award ceremonies, and international
    entertainment events. With years of industry expertise, we deliver
    high-impact events that combine creativity, strategic planning, and
    flawless on-ground execution.
  </p>

  <p>
    Our dedicated team handles complete end-to-end event solutions,
    including artist management, talent booking, venue sourcing,
    production setup, technical coordination, logistics planning,
    hospitality management, and audience engagement strategies.
    We focus on delivering seamless experiences that align with your
    brand identity and business objectives.
  </p>

  <h3>Events We Manage</h3>

  <ul>
    <li>Celebrity Live Shows & Concerts</li>
    <li>Corporate Annual Meets & Award Nights</li>
    <li>Luxury Destination Events</li>
    <li>International Event Coordination</li>
    <li>MICE (Meetings, Incentives, Conferences & Exhibitions)</li>
  </ul>

  <h3>Why Choose Atlas Travel House for Event Management?</h3>

  <p>
    Our reputation is built on reliability, creativity, and precision.
    We understand that every event is unique, which is why we offer
    customized solutions tailored to client requirements. From concept
    development to final execution, our focus remains on quality,
    innovation, and delivering memorable experiences that leave a
    lasting impression.
  </p>

  <p>
    Whether you are planning a large-scale celebrity concert,
    a high-profile corporate gathering, or an international destination
    event, Atlas Travel House ensures professional management,
    transparent communication, and flawless delivery every time.
  </p>
</section>

      <section className="events-gallery" ref={containerRef}>
        {/* <h2 className="visually-hidden">Event Highlights Gallery</h2> */}

        <div className="grids-container">
          {media.map((item, idx) => (
            <figure
              className={`panel ${idx % 2 === 0 ? "from-left" : "from-right"}`}
              key={idx}
            >
              {item.endsWith(".webm") ? (
                <video
                  src={item}
                  autoPlay
                  loop
                  muted
                  playsInline
                  preload="metadata"
                />
              ) : (
                <img
                  src={item}
                  alt="Celebrity and corporate event managed by Atlas Travel House"
                  loading="lazy"
                />
              )}
            </figure>
          ))}
        </div>
      </section>

    </main>
  );
}

export default Events;